import { CampaignBlocks, } from "@kvix/shared";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { motion, useTransform, useViewportScroll } from "framer-motion";
import React, { useContext, useRef } from "react";
import { AdminFormFilePicker } from "../admin";
import { AdminCampaignContentContext } from "../context/adminCampaignContentContext";
import { useRefScrollProgress } from "../utils/getRefScrollProgress";
import { useWindowSize } from "../utils/getWindowSize";
const useStyles = makeStyles((theme) => ({
    centerBlock: {
        overflowX: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "820px",
        padding: " 0",
        margin: "0",
        width: "100%",
        position: "relative",
        [theme.breakpoints.up("sm")]: {
            padding: "120px 0",
            height: "707px",
        },
    },
    motionWrapper: {
        overflow: "hidden",
        position: "absolute",
        top: 0,
    },
    videoWrapper: {
        display: "flex",
        justifyContent: "center",
    },
    video: {
        maxWidth: "100%",
        height: "820px",
        objectFit: "cover",
        [theme.breakpoints.up("sm")]: {
            height: "707px",
            maxWidth: "1256px",
        },
    },
}));
export class LoopVideoBlock {
    constructor() {
        this.defaultStructure = {
            name: CampaignBlocks.LoopVideoBlock,
            media: { videos: [""] },
        };
        this.Render = (props) => {
            const { block } = props;
            const { scrollY } = useViewportScroll();
            const inputRef = useRef(null);
            const { start, end } = useRefScrollProgress(inputRef);
            const size = useWindowSize();
            const actualStart = start - size.height;
            const width = useTransform(scrollY, [actualStart, actualStart + 200], [1, 1256]);
            const height = useTransform(scrollY, [actualStart, actualStart + 200, actualStart + 400], [1, 1, 707]);
            const heightSpacer = useTransform(scrollY, [2200, 2600, 2605], [500, 500, 60]);
            //mobile
            const theme = useTheme();
            const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
            const widthMob = useTransform(scrollY, [actualStart + 300, actualStart + 500], [1, 1256]);
            const heightMob = useTransform(scrollY, [actualStart, actualStart + 450, actualStart + 600], [1, 1, 820]);
            const classes = useStyles();
            const adminContext = useContext(AdminCampaignContentContext);
            return (React.createElement("div", { className: classes.centerBlock },
                React.createElement("div", { ref: inputRef, className: classes.motionWrapper }, adminContext === null ? (React.createElement(motion.div, { style: isMobile
                        ? {
                            ["width"]: widthMob,
                            ["height"]: heightMob,
                        }
                        : {
                            perspective: 600,
                            ["width"]: width,
                            ["height"]: height,
                        } },
                    React.createElement(motion.div, { className: classes.videoWrapper, style: !isMobile
                            ? {
                                originY: 0,
                                ["height"]: heightSpacer,
                            }
                            : null, animate: { rotateX: 360 }, transition: { duration: 0.8, delay: 0.3 } },
                        React.createElement("video", { muted: true, autoPlay: true, loop: true, className: classes.video },
                            React.createElement("source", { src: block.media.videos[0] }))))) : (React.createElement("div", { className: classes.videoWrapper },
                    React.createElement("video", { muted: true, autoPlay: true, loop: true, className: classes.video },
                        React.createElement("source", { src: block.media.videos[0] })))))));
        };
        this.Compose = (props) => {
            const { block } = props;
            const { updateContent } = useContext(AdminCampaignContentContext);
            const filePicker = (file) => {
                block.media.videos[0] = file;
                updateContent(block);
            };
            return (React.createElement(AdminFormFilePicker, { name: "video", acceptedFileTypes: ["video/*"], label: "Video - recommended size: 1280x720 px, max duration: 30s ", folder: "campaign", onChange: filePicker, required: true, file: block.media.videos[0] }));
        };
    }
}
//# sourceMappingURL=LoopVideoBlock.js.map